import { alpha, Chip, styled } from '@mui/material';

const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  color: theme.vars.palette.primary.main,
  fontWeight: 600,
  fontSize: '0.75rem',
  lineHeight: '166%',
  backgroundColor: alpha(theme.palette.primary.main, 0.25),
}));

export const BetaChip = () => {
  return <StyledChip label='Beta' />;
};
